"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const blackheadsskin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-blackheadsskin` : '') + (description ? ` desc-blackheadsskin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-blackheadsskin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-blackheadsskin"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_26071_3579)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.51 18.9a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.19Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.32 18.9a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.19Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.82 18.9a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.19Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.6 18.9a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.5 15.15a1.1 1.1 0 1 1 .01 2.2 1.1 1.1 0 0 1 0-2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.04 15.15a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.19Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.57 15.15a1.1 1.1 0 1 1 0 2.19 1.1 1.1 0 0 1 0-2.19Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.82 7.4c1.08 0 2.1.59 2.9 1.28.6.5 1.1 1.1 1.47 1.6a.75.75 0 0 1 .38-.13 5.59 5.59 0 0 1 4.49.54l2.8 1.66a.75.75 0 0 1-.76 1.29l-2.8-1.66a4.1 4.1 0 0 0-3.27-.4 6.72 6.72 0 0 1-5.18 2.32 7.42 7.42 0 0 1-5.54-2.48c-.75 0-1.5.2-2.16.6l-2.66 1.64a.75.75 0 1 1-.78-1.27l2.65-1.64a5.64 5.64 0 0 1 4.23-.69c.37-.47.85-1 1.41-1.46.8-.66 1.77-1.2 2.82-1.2Zm.03 1.08c-1.52 0-2.75.78-2.75 1.75s1.23 0 2.75 0 2.75.97 2.75 0-1.23-1.75-2.75-1.75Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.09 3.48a.75.75 0 0 1 1.06.03l1.94 2.08A.75.75 0 0 1 8 6.6L6.06 4.54a.75.75 0 0 1 .04-1.06Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.05 3.51a.75.75 0 0 1 1.1 1.03L15.21 6.6a.75.75 0 0 1-1.1-1.02l1.94-2.08Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.88.85c.41 0 .75.34.75.75v3.46a.75.75 0 0 1-1.5 0V1.6c0-.41.34-.75.75-.75Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_26071_3579"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = blackheadsskin;